import _ from 'lodash';
import { useEffect, useState } from 'react';
import { getLastTransactionForMultipleRuns, getRuns } from 'common/api/run';
import { ORDER_TYPES } from 'common/constants/index';
import LoadingSpinner from 'common/components/LoadingSpinner';
import LiveRunCard from './LiveRunCard';
import RecentTransactions from './RecentTransactions';

const propTypes = {};
const defaultProps = {};

// TODO: Move this as a seperate generic component outside of Home.
const LiveTransactions = () => {
  const [runningStrategies, setRunningStrategies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { automatic: { value: automatic }, oneClick: { value: oneclick } } = ORDER_TYPES;

  const getSortId = (orderType) => {
    switch (orderType) {
      case automatic: return 0;
      case oneclick: return 1;
      default: return 2;
    }
  };

  const orderedStrategies = _.orderBy(runningStrategies, ['sortId', 'created_at'], ['asc', 'desc']);

    const daySquareOffCount = runningStrategies.filter(
    (run) => run.status === 'day_squareoff'
  ).length;

  useEffect(() => {
    async function fetchOrders() {
      const resultRuns = await getRuns({
        params:
         { offsetRunId: 0, filter_type: 'running_live_runs' }
      });
      const lastTransactions = await getLastTransactionForMultipleRuns(_.map(resultRuns, 'id'));

      const modifiedRuns = _.map(resultRuns, (resultRun) => {
        const { order_type: orderType } = resultRun;
        return { ...resultRun, sortId: getSortId(orderType), orders: lastTransactions[resultRun.id] };
      });

      setIsLoading(false);
      setRunningStrategies(modifiedRuns);
    }
    fetchOrders();
  }, []);

  const renderRunningStrategies = (run, idx) => {
    if (_.isEmpty(run)) return null;
    return <LiveRunCard run={run} key={idx} />;
  };

  if (_.isEmpty(orderedStrategies)) return null;

  return (
    <div className="live-transactions-container mb-6">
      <RecentTransactions
        totalRuns={runningStrategies.length}
        daySquareOffCount={daySquareOffCount}
      />
      <LoadingSpinner isLoading={isLoading}>
        {_.map(orderedStrategies, renderRunningStrategies)}
      </LoadingSpinner>
    </div>
  );
};

LiveTransactions.propTypes = propTypes;
LiveTransactions.defaultProps = defaultProps;

export default LiveTransactions;
